import React from 'react';

import PropTypes from 'prop-types';

import { isCompanyAuthorizedSignerType, isSecurityGroupSignerType } from '../../Signature.utils';
import CompanyAuthorizedSignerConfig from '../CompanyAuthorizedSignerConfig';
import SecurityGroupSignerConfig from '../SecurityGroupSignerConfig';

const SignerTypeExtendedConfig = ({
  form,
  securityGroupOptions,
  validationErrors,
  onAutocompleteChange,
}) => {
  const isCompanyAuthorizedSigner = isCompanyAuthorizedSignerType(form.signerType);
  const isSecurityGroupSigner = isSecurityGroupSignerType(form.signerType);

  return (
    <>
      {isCompanyAuthorizedSigner && (
        <CompanyAuthorizedSignerConfig
          form={form}
          validationErrors={validationErrors}
          onAutocompleteChange={onAutocompleteChange}
        />
      )}
      {isSecurityGroupSigner && (
        <SecurityGroupSignerConfig
          form={form}
          securityGroupOptions={securityGroupOptions}
          validationErrors={validationErrors}
          onAutocompleteChange={onAutocompleteChange}
        />
      )}
    </>
  );
};

SignerTypeExtendedConfig.propTypes = {
  form: PropTypes.object.isRequired,
  securityGroupOptions: PropTypes.array.isRequired,
  validationErrors: PropTypes.object.isRequired,
  onAutocompleteChange: PropTypes.func.isRequired,
};

export default SignerTypeExtendedConfig;
